import { Form } from '@vivaldis/antd-ui'
import type { EmployeeInput } from '@vivaldis/graphql'
import { ActionBar } from './components/ActionBar'
import { FormContent } from './components/FormContent'
import { FormProvider } from './provider/FormProvider'
import { Employee } from './types/Employee'

interface Props {
  employee: Employee
  onSubmit: (employeeInput: EmployeeInput) => Promise<void>
  taxCodes: string[]
}

export const EditEmployeeWageProfileForm = ({
  employee,
  onSubmit,
  taxCodes
}: Props) => {
  return (
    <FormProvider employee={employee} onSubmit={onSubmit}>
      <Form
        id="edit-employee-work-profile-form"
        name="edit-employee-work-profile-form"
        autoComplete="off"
      >
        <FormContent taxCodes={taxCodes} />
        <ActionBar />
      </Form>
    </FormProvider>
  )
}
